import { Link } from "react-router-dom";
import { BadgePercent, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

export default function Shopping() {
    return (
        <section id="shopping" data-testid="shopping-section" className="relative py-24 sm:py-32 overflow-hidden">
            <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[50rem] h-[30rem] gold-glow pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
                <div className="grid lg:grid-cols-12 gap-12 items-start">
                    <Reveal className="lg:col-span-7">
                        <Overline>Shopping</Overline>
                        <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">
                            Shop recommendations <span className="italic text-amber-500">tailored to you.</span>
                        </h2>
                        <p className="mt-8 text-base sm:text-lg leading-relaxed text-zinc-400 max-w-2xl">
                            LookAura can connect personalized style recommendations with relevant products from participating online retailers. When a recommendation fits your analysis, you can move from inspiration to the actual product in a tap.
                        </p>
                    </Reveal>

                    <Reveal delay={0.15} className="lg:col-span-5">
                        <aside
                            data-testid="affiliate-disclosure-note"
                            className="border border-amber-600/40 bg-[#0A0A0A] p-8 lg:p-10"
                        >
                            <BadgePercent className="w-7 h-7 text-amber-500 mb-5" strokeWidth={1.25} />
                            <h3 className="font-serif-display text-xl text-[#FAFAFA] mb-3">Affiliate Disclosure</h3>
                            <p className="text-sm leading-relaxed text-zinc-400">
                                Some product links may be affiliate links. LookAura may earn a commission when you make a purchase through these links, at no additional cost to you.
                            </p>
                            <Link
                                to="/affiliate-disclosure"
                                data-testid="shopping-affiliate-link"
                                className="group mt-6 inline-flex items-center gap-2 text-sm text-amber-400 hover:text-amber-300 transition-colors"
                            >
                                Read the full disclosure
                                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </Link>
                        </aside>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
